module.exports = __webpack_public_path__ + "img/success.91720241.png";